import { isPlatformServer, isPlatformBrowser } from "@angular/common";
import { OnInit, OnDestroy, Component, inject, PLATFORM_ID } from "@angular/core";

@Component({ selector: '_newpla-base-component2', template: '' })
export abstract class NewplaBaseComponent2 implements OnInit, OnDestroy {

    protected readonly _platformId = inject(PLATFORM_ID);

    serverNgOnInit!: () => void;
    browserNgOnInit!: () => void;

    serverNgOnDestroy!: () => void;
    browserNgOnDestroy!: () => void;

    ngOnInit(): void {
        if (isPlatformServer(this._platformId)) { this.serverNgOnInit && this.serverNgOnInit() }
        if (isPlatformBrowser(this._platformId)) { this.browserNgOnInit && this.browserNgOnInit(); }
    }

    ngOnDestroy(): void {
        if (isPlatformServer(this._platformId)) { this.serverNgOnDestroy && this.serverNgOnDestroy() }
        if (isPlatformBrowser(this._platformId)) { this.browserNgOnDestroy && this.browserNgOnDestroy(); }
    }

}